import wixData from 'wix-data';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';
import { authentication } from 'wix-members';

var user;

$w.onReady(function () {
	init();

	wixLocation.onChange(e => {
		init();
	});

	authentication.onLogin(info => {
		init();
	})

	authentication.onLogout(() => {
		init();
	})
});

export function init() {
	user = wixUsers.currentUser;
	if(user.loggedIn) {
		$w("#formBox").show();
		$w("#formBox").expand();
		$w("#reviewLogin").hide();
		$w("#reviewLogin").collapse();
		$w("#loginBtn").hide();
		$w("#loginBtn").collapse();
	} else {
		$w("#formBox").hide();
		$w("#formBox").collapse();
		$w("#reviewLogin").show();
		$w("#reviewLogin").expand();
		$w("#loginBtn").show();
		$w("#loginBtn").expand();
	}

	getProductQuotes();
	getProductArticles();
	getRatings();
	getReviews();
}

export function getRatings() {
	$w("#ratings").numRatings = 0;
	$w("#ratings").rating = 0;
	$w("#ratingNum").text = `(0 رای‌دهنده)`;

	$w("#productPage1").getProduct().then(product => {
		wixData.query('StoreRatings').eq('product', product._id).find().then(res => {
			if(res.items.length > 0) {
				var rating = res.items[0];
				$w("#ratings").numRatings = rating.count;
				$w("#ratings").rating = rating.rate/rating.count;
				$w("#ratingNum").text = `(${rating.count} رای‌دهنده)`;
				console.log('RATINGGGGGGGGG');
				console.log(rating);
			} else {	
				console.log('no ratings yet!');
				$w("#ratings").numRatings = 0;
				$w("#ratings").rating = 0;
				$w("#ratingNum").text = `(0 رای‌دهنده)`;
			}
		})
	});
}

export function getReviews() {
	$w("#productPage1").getProduct().then(product => {
		wixData.query('StoreReviews').eq('product', product._id).include('user').find().then(res => {
			if(res.items.length > 0) {
				$w("#reviews").data = res.items;
				$w("#reviews").show();
				$w("#reviews").expand();
				$w("#noReview").hide();
				$w("#noReview").collapse();
			} else {	
				console.log('no reviews yet!');
				$w("#reviews").hide();
				$w("#reviews").collapse();
				$w("#noReview").show();
				$w("#noReview").expand();
			}
		})
	});
}

export function reviews_itemReady($item, itemData, index) {
		$item("#rating").numRatings = 1;
		$item("#rating").rating = itemData.rate;
		$item("#review").text = itemData.review;
		$item("#username").text = itemData.user.nickname;
		$item("#datetime").text = itemData._publishDate.toLocaleDateString();
}

export function formSubmit_click(event) {
	$w("#formSubmit").disable();
	user.getEmail().then(email => {
		wixData.query('Members/PrivateMembersData').eq('loginEmail', email).find().then(userData => {
			$w("#productPage1").getProduct().then(product => {
				wixData.insert('StoreReviews', {
				user: userData.items[0]._id,
				product: product._id,
				rate: $w("#formRating").value,
				review: $w("#formReview").value
			}).then(res => {
				console.log(res);
				wixLocation.to(wixLocation.url);
				})
			})
		})
	})
}

export function repeater1_itemReady($item, itemData, index) {
	let t = itemData.text.replace(/(&zwnj;)+/g, '‌'); //half-space
	$item("#text22").html = t;
	$item("#text21").text = $item("#text22").text.trim();
	console.log($item("#text21").text)
}

export function getProductQuotes() {
	$w("#productPage1").getProduct().then(product => {
		wixData.query("quotes").include("author").hasSome("book", [product._id]).limit(5).find().then(res => {
			if(res.items.length > 0) {
				$w("#repeater1").data = res.items;
				if( res.items[0].author &&  res.items[0].author.length > 0) {
					$w("#authorImage").src = res.items[0].author[0].image;
					$w("#authorName").text = res.items[0].author[0].title;
					$w("#authorCaption").text = res.items[0].author[0].caption;
					$w("#authorBirth").text = res.items[0].author[0].birth;
					$w("#authorLink").link = res.items[0].author[0]['link-authors-title'];
				} else {
					$w("#authorName").text = '';
					$w("#authorCaption").text = '';
					$w("#authorBirth").text = '';
				}
				
				$w("#box1").show();
				$w("#box1").expand();
			} else {
				$w("#box1").hide();
				$w("#box1").collapse();
			}
		})
	})
}

export function getProductArticles() {
	$w("#productPage1").getProduct().then(product => {
		wixData.query("Blog/Posts").hasSome("hashtags", [product.name, product.name.replace(/\s/g, '_'), product.name.replace(/\s/g, '')]).find().then(res => {
			if(res.items.length > 0) {
				res.items.forEach((a, i) => {
					var image = String(a.coverImage.replace("wix:image://v1/", ''));
					image = image.substr(image.indexOf('/'));
					image = 'https://static.wixstatic.com/media' + image;
					$w("#articles").setAttribute("article-"+i, JSON.stringify({ title: a.title, image: image, url: a.postPageUrl }))
				})
				$w("#articlesTitle").show();
				$w("#articlesTitle").expand();
				$w("#articles").show();
				$w("#articles").expand();
			} else {
				$w("#articlesTitle").collapse();
				$w("#articlesTitle").hide();
				$w("#articles").collapse();
				$w("#articles").hide();
			}
		})
	})
}

/**
*	Sets the function that runs when a new repeated item is created.
	[Read more](https://www.wix.com/corvid/reference/$w.Repeater.html#onItemReady)
*	 @param {$w.$w} $item
*/


/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
